"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Navigation = function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { className: "estimateForm-Navigation_Box" },
        react_1.default.createElement("div", { className: "estimateForm-Navigation_Title" },
            "\u7C21\u5358",
            store.navigationItems.length,
            "\u30B9\u30C6\u30C3\u30D7\u3067\u5B8C\u4E86\uFF01"),
        react_1.default.createElement("div", { className: "estimateForm-Navigation_ItemWrapper" }, store.navigationItems.map(function (item, idx) { return (react_1.default.createElement("div", { key: idx, className: store.navigationItemClassName(idx + 1) }, item.join('\n'))); }))));
};
exports.default = Navigation;
